import * as React from 'react';
import CustomComponentContext from '../CustomComponentContext';
import DeliveryInstructions from '../DeliveryInstructions';
import {
  DeliveryInstructionsProvider,
  UI_STATE,
  DEFAULT_DELIVERY_INSTRUCTIONS_CONTEXT,
} from '../../hooks/useDeliveryInstructionsState';
import PickupPointOrRTH from '../PickupPointOrRTH';
import {
  RedirectToHoldProvider,
  DEFAULT_REDIRECT_TO_HOLD_CONTEXT,
} from '../../hooks/useRedirectToHoldState';
import LasershipDeliveryInstructions from '../LasershipDeliveryInstructions';
import ScheduleDelivery from '../ScheduleDelivery';

const DeliveryManagement: React.FunctionComponent = () => {
  const { state } = React.useContext(CustomComponentContext);

  const featureName =
    typeof state?.settings?.featureName === 'string'
      ? state.settings.featureName
      : '';

  switch (featureName) {
    case 'redirectToHold':
    case 'pickupPointDetails':
      return (
        <RedirectToHoldProvider initialState={DEFAULT_REDIRECT_TO_HOLD_CONTEXT}>
          <PickupPointOrRTH />
        </RedirectToHoldProvider>
      );
    case 'deliveryInstructions':
      switch (state?.pageContext.carrier) {
        case 'lasership':
          return <LasershipDeliveryInstructions />;
        default:
          return (
            <DeliveryInstructionsProvider
              initialState={{
                ...DEFAULT_DELIVERY_INSTRUCTIONS_CONTEXT,
                deliveryInstructionsUIState: UI_STATE.INITIAL,
              }}
            >
              <DeliveryInstructions />
            </DeliveryInstructionsProvider>
          );
      }
    case 'scheduledDelivery':
      switch (state?.pageContext.carrier) {
        case 'sagawa-v2':
        case 'metro':
          return <ScheduleDelivery />;
        case 'pilot':
          return null;
        default:
          return null;
      }
    default:
      return null;
  }
};

export default DeliveryManagement;
